import { laisPath } from '../laisRouteHelpers';
import RentFlowsIndex from '../laisTenantsRentFlows/pages/RentFlowsIndex.vue';

export const routes = [
  {
    path: laisPath('propostas'),
    component: RentFlowsIndex,
    meta: { referenceAuthenticated: true },
  },
];
